import {makeAutoObservable} from "mobx";

export class UserStorage {
    USER = 'marketplace-user';
    constructor(storage) {
        this._storage = storage;
        this._user = this._storage.get(this.USER) || null;
        makeAutoObservable(this);
    }

    removeUser() {
        this._user = undefined
        this._storage.remove(this.USER)
    }

    addUser(user) {
        this._user = JSON.stringify(user)
        this._storage.add(this.USER, this._user);
    }

    getUser() {
        this._user = this._storage.get(this.USER);
        return JSON.parse(this._user)
    }

    hasUser() {
        const user = this.getUser();
        return user !== null && user !== undefined;
    }
}
